import { Box } from "@mui/material";
import { SubscriptionProductDto } from "@/dto/SubscriptionDto";
import useSubscriptionList from "./useSubscriptionList";
import Subscription from "@/organism/Subscription";

export type ListProps = {
  list: SubscriptionProductDto[];
  isLoading: boolean;
};

export const List = (props: ListProps) => {
  const { list, isLoading } = props;
  const { handleDetail } = useSubscriptionList();

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Subscription.List
        isLoading={isLoading}
        list={list}
        onDetail={handleDetail}
      />
    </Box>
  );
};
